import { render, staticRenderFns } from "./ppnmasukan.vue?vue&type=template&id=3cfde6d0&scoped=true"
import script from "./ppnmasukan.vue?vue&type=script&lang=js"
export * from "./ppnmasukan.vue?vue&type=script&lang=js"
import style0 from "./ppnmasukan.vue?vue&type=style&index=0&id=3cfde6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfde6d0",
  null
  
)

export default component.exports